import ImageContentBlock from 'models/common/content/block/ImageContentBlock';

export default class ImageContentBlockService {
	toModel(block) {
		return new ImageContentBlock(block);
	}
}
